import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LogicResult, SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import { Observable } from 'rxjs';
import { ConfigService } from '../../services/config.service';

@Injectable()
export class AssignService {
    private http = inject(HttpClient);
    private config = inject(ConfigService);

    assignTo(
        entityType: SystemEntity,
        entityId: string,
        partyId: string,
    ): Observable<any> {
        return this.http.patch<any>(
            `${
                this.config.getConfiguration().API_BASE
            }/${entityType.toLowerCase()}/${entityId}/assign/${partyId}`,
            {},
        );
    }

    bulkAssignTo(
        entityType: SystemEntity,
        entityIds: string[],
        partyId: string,
    ): Observable<LogicResult[]> {
        const url = `${
            this.config.getConfiguration().API_BASE
        }/${entityType.toLowerCase()}/assign/${partyId}`;
        return entityType === SystemEntity.ExternalTask
            ? this.http.patch<LogicResult[]>(url, entityIds)
            : this.http.post<LogicResult[]>(url, entityIds);
    }

    bulkUnassign(
        entityType: SystemEntity,
        entityIds: string[],
    ): Observable<LogicResult[]> {
        return this.http.patch<LogicResult[]>(
            `${
                this.config.getConfiguration().API_BASE
            }/${entityType.toLowerCase()}/unassign`,
            entityIds,
        );
    }
}
